export const localStorageKey = {
  isPdfViewerFirstVisit: 'isPdfViewerFirstVisit',
  emailFormSubmitHistoryId: 'efshi',
  pdfViewerVersion: 'pdfViewerVersion',
} as const;
